// MODIFIED: Cleaned up imports and moved logic to useSmartSalaryRateMatcher
import React, { useEffect } from 'react';
import { EntityPickerField } from '../EntityPicker/EntityPickerField';
import { useSalaryRateMatcher } from '../../../v2/hooks/useSalaryRateMatcher'; // REPLACED: Logic now lives here
import { useEmployeeType } from '../../../v2/hooks/useEmployeeType';

// ── MSC-specific configuration (REMAINS UNCHANGED) ──────────────────────────
export const MSC_V2_CONFIG = {
  entityName: "Salary Rule",
  idField: "id",
  displayFields: {
    primary: "description",
    secondary: "maintenanceSalaryCombinationCodeCode"
  },
  tableHeaders: ["Code", "Description", "Daily Rate"],
  tableAccessors: ["maintenanceSalaryCombinationCodeCode", "description", "dailyRate"],
  searchFields: [
    { label: "All", field: "all", index: 0 },
    { label: "Description", field: "description", index: 1 },
    { label: "Code", field: "maintenanceSalaryCombinationCodeCode", index: 2 },
  ],
  placeholder: "--Select salary rule--"
};

// ── MaintenanceSalaryCombinationV2PickerSelect wrapper ───────────────────────
export function MaintenanceSalaryCombinationV2PickerSelect({
  label,
  context,
  salaryType,
  effectiveDate = null,
  keyMap,
  value,
  onSelect,
  onClear,
  placeholder = "--Select salary rule--",
  disabled = false,
  isRequired = false,
  className = "",
  error = false,
  errorMessage = ""
}) {

  const { activeData: activeEmployeeTypes, fetchActiveData: fetchActiveEmployeeTypesData } = useEmployeeType({ isMainModule: false }); // Fetches the list with flags

  // REPLACED: Internal useEffect/State with the Smart Matcher hook
  const { matchedRules: entities, loading } = useSalaryRateMatcher({
    formState: context,
    salaryType: salaryType,
    activeEmployeeTypes,
    keyMap: keyMap,
    effectiveDate
  });

  useEffect(() => { fetchActiveEmployeeTypesData(); }, [fetchActiveEmployeeTypesData]);
  
  return (
    <div className="mb-1 w-full">
      {label && (
        <label className="mb-1.5 block text-sm font-medium text-gray-600">
          {label} {loading && <span className="text-[10px] animate-pulse">(Searching...)</span>}
          {isRequired && <span className="ml-1 text-red-500">*</span>}
        </label>
      )}

      <select
        className={`w-full border border-gray-300 rounded-md px-3 h-[33px] transition-all cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 ${disabled ? 'bg-gray-100' : 'bg-white'} ${className}`}
        value={value || ""}
        disabled={disabled || loading}
        onChange={(e) => {
          const id = e.target.value;
          if (!id) onClear?.();
          else {
            const match = entities.find(r => r.id.toString() === id.toString());
            onSelect(match);
          }
        }}
      >
        <option value="">{entities.length > 0 ? placeholder : "-- No matching rates found --"}</option>
        {entities.map(item => (
          <option key={item.id} value={item.id}>
            {`${item.maintenanceSalaryCombinationCodeCode} (Rate: ${item.dailyRate})`}
          </option>
        ))}
      </select>

      {error && <span className="mt-1 block text-sm text-red-500">{errorMessage}</span>}

      {/* Maintain the custom criteria warning */}
      {!loading && entities.length === 0 && salaryType === "MaintenanceSalaryCombination" && (
        <span className="mt-1 block text-[10px] font-bold text-red-400 uppercase">
          Missing required criteria for rate matching
        </span>
      )}
    </div>
  );
}

// ── MaintenanceSalaryCombinationV2PickerField (REMAINS UNCHANGED) ───────────
export function MaintenanceSalaryCombinationV2PickerField({
  maintenanceSalaryCombinationV2Id,
  displayValue = "",
  onSelect,
  onClear,
  ...rest
}) {
  return (
    <EntityPickerField
      {...rest}
      config={MSC_V2_CONFIG}
      entityId={maintenanceSalaryCombinationV2Id}
      displayValue={displayValue}
      onSelect={onSelect}
      onClear={onClear}
    />
  );
}